import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const ImageBanner = ({ image, alt }) => (
  <div className="image-banner ratio-5-4 pos-rel">
    <GatsbyImage image={image} alt={alt} className="bg-image" />
  </div>
)

export default ImageBanner
